module.exports = __webpack_public_path__ + "img/photo-sport-2.33e7d195.png";